/* eslint-disable class-methods-use-this */
import axios from 'axios';
import authHeader from '@/services/auth-header';
// import * as XLSX from 'xlsx';

// eslint-disable-next-line import/no-extraneous-dependencies
import * as XLSX from 'xlsx-js-style';

const API_URL = `${process.env.VUE_APP_API_URL}`;

class N3Service {
  getWorkersN3EntriesInRange(workCenterId, selectedYear) {
    return axios
      .get(`${API_URL}n3/workcenter-n3-in-year/${workCenterId}`, { params: { year: selectedYear }, headers: authHeader() })
      .then((response) => response.data);
  }

  getN3EntriesInRange(workerId, selectedYear) {
    return axios
      .get(`${API_URL}n3/n3-in-year/${workerId}`, { params: { year: selectedYear }, headers: authHeader() })
      .then((response) => response.data);
  }

  addFixedN3EntriesForYear(yearSel, amountSel) {
    const n3Dto = {
      year: yearSel,
      amount: amountSel,
    };
    return axios
      .post(`${API_URL}n3/add-fixed-n3-year`, n3Dto, {
        headers: authHeader(),
      })
      .then((response) => response.data);
  }

  addWorkerN3Entry(yearSel, monthSel, amountSel) {
    const n3Dto = {
      year: yearSel,
      month: monthSel,
      amount: amountSel,
    };
    return axios
      .post(`${API_URL}n3/add-n3-entry`, n3Dto, {
        headers: authHeader(),
      })
      .then((response) => response.data);
  }

  addAdminN3Entry(workerId, yearSel, monthSel, amountSel) {
    const n3Dto = {
      year: yearSel,
      month: monthSel,
      amount: amountSel,
    };
    return axios
      .post(`${API_URL}n3/add-admin-n3-entry/${workerId}`, n3Dto, {
        headers: authHeader(),
      })
      .then((response) => response.data);
  }

  addAdminFixedN3EntriesForYear(workerId, yearSel, amountSel) {
    const n3Dto = {
      year: yearSel,
      amount: amountSel,
    };
    return axios
      .post(`${API_URL}n3/add-admin-fixed-n3-year/${workerId}`, n3Dto, {
        headers: authHeader(),
      })
      .then((response) => response.data);
  }

  editN3Entry(n3Id, yearSel, monthSel, amountSel) {
    const n3Dto = {
      year: yearSel,
      month: monthSel,
      amount: amountSel,
    };
    return axios
      .post(`${API_URL}n3/edit-n3-entry/${n3Id}`, n3Dto, {
        headers: authHeader(),
      })
      .then((response) => response.data);
  }

  editAdminN3Entry(n3Id, yearSel, monthSel, amountSel) {
    const n3Dto = {
      year: yearSel,
      month: monthSel,
      amount: amountSel,
    };
    return axios
      .post(`${API_URL}n3/edit-admin-n3-entry/${n3Id}`, n3Dto, {
        headers: authHeader(),
      })
      .then((response) => response.data);
  }

  // @PostMapping("/approve-n3-entry/{workerId}/{n3Id}/{isApproved}")
  approveN3Entry(workerId, n3Id, isApproved) {
    return axios
      .post(`${API_URL}n3/approve-n3-entry/${workerId}/${n3Id}/${isApproved}`, {}, {
        headers: authHeader(),
      })
      .then((response) => response.data);
  }

  deleteN3Entry(n3Id) {
    return axios
      .delete(`${API_URL}n3/delete-n3-entry/${n3Id}`, {
        headers: authHeader(),
      })
      .then((response) => response.data);
  }

  deleteAdminN3Entry(n3Id) {
    return axios
      .delete(`${API_URL}n3/delete-admin-n3-entry/${n3Id}`, {
        headers: authHeader(),
      })
      .then((response) => response.data);
  }

  downloadN3EntriesForAllWorkers(n3Entries, year, workcenterName, workCenterId) {
    const filterApproved = true;
    if (filterApproved) {
      // eslint-disable-next-line no-param-reassign
      n3Entries = n3Entries.filter((entry) => entry.approved === true);
    }
    const months = this.getMonthsForYear(year);
    const n3EntriesExport = n3Entries.map((item) => {
      const outItem = JSON.parse(JSON.stringify(item));
      // Renombrar campos

      outItem.DNI = outItem.idDocument;
      delete outItem.idDocument;

      outItem.ApellidosYNombre = `${outItem.workerLastName} ${outItem.workerName}`;
      delete outItem.workerName;
      delete outItem.workerLastName;

      outItem.AnticipoQuincenal = outItem.amount ? String(outItem.amount).replace('.', ',') : '';
      delete outItem.amount;

      outItem.observaciones = outItem.information;
      delete outItem.information;

      if (!filterApproved) {
        outItem.Aprobado = outItem.approved;
      }

      delete outItem.approved;

      // Eliminar campos
      delete outItem.id;
      delete outItem.workerId;
      delete outItem.worker;
      delete outItem.workerEmail;
      delete outItem.year;
      delete outItem.workcenterName;

      return outItem;
    });

    // Crear el libro de Excel
    const wb = XLSX.utils.book_new();
    months.forEach((month) => {
      const n3EntriesFilteredByMonth = n3EntriesExport.filter((entry) => entry.month === month.monthNumber).map((item) => {
        const outItem = JSON.parse(JSON.stringify(item));
        // Eliminar el campo month ya que cada hoja corresponde a un mes específico
        delete outItem.month;
        return outItem;
      });
      const ws = XLSX.utils.json_to_sheet(n3EntriesFilteredByMonth, { origin: 'A6' });
      this.addHeadersToSheet(ws, month.monthName, year, workcenterName, workCenterId);

      // Auto-width columns A, B, C, D
      const wscols = [
        { wch: 25 }, // A: DNI
        { wch: 40 }, // B: ApellidosYNombre
      ];

      if (n3EntriesFilteredByMonth.length > 0) {
        const keys = Object.keys(n3EntriesFilteredByMonth[0]);
        keys.forEach((key, i) => {
          if (i < wscols.length) {
            const maxLen = n3EntriesFilteredByMonth.reduce((max, row) => Math.max(max, row[key] ? String(row[key]).length : 0), key.length);
            if (maxLen + 2 > wscols[i].wch) wscols[i].wch = maxLen + 2;
          }
        });
      }
      ws['!cols'] = wscols;

      const totalAmount = n3EntriesFilteredByMonth.reduce((sum, item) => {
        const val = item.AnticipoQuincenal ? parseFloat(item.AnticipoQuincenal.replace(',', '.')) : 0;
        return sum + val;
      }, 0).toFixed(2).replace('.', ',');
      const nextRow = 7 + n3EntriesFilteredByMonth.length;
      XLSX.utils.sheet_add_aoa(ws, [['', 'SUMAS:      ', `${totalAmount} €`, '']], { origin: `A${nextRow}` });

      // Apply default font Arial to all cells
      const range = XLSX.utils.decode_range(ws['!ref']);
      for (let R = range.s.r; R <= range.e.r; R += 1) {
        for (let C = range.s.c; C <= range.e.c; C += 1) {
          const cellRef = XLSX.utils.encode_cell({ c: C, r: R });
          if (ws[cellRef]) {
            if (!ws[cellRef].s) ws[cellRef].s = {};
            if (!ws[cellRef].s.font) ws[cellRef].s.font = {};
            if (!ws[cellRef].s.font.name) ws[cellRef].s.font.name = 'Arial';
            // You can set other default styles here if needed
            // font size = 10
            if (!ws[cellRef].s.font.sz) ws[cellRef].s.font.sz = 10;
            // borber bottom style dotted
            if (!ws[cellRef].s.border) ws[cellRef].s.border = {};
            if (!ws[cellRef].s.border.bottom) ws[cellRef].s.border.bottom = { style: 'dotted', color: { rgb: '000000' } };
            // border right medium
            if (!ws[cellRef].s.border.right) ws[cellRef].s.border.right = { style: 'medium', color: { rgb: '000000' } };

            // Alignment
            if (!ws[cellRef].s.alignment) ws[cellRef].s.alignment = {};
            if (!ws[cellRef].s.alignment.vertical) ws[cellRef].s.alignment.vertical = 'center';
            if (!ws[cellRef].s.alignment.horizontal) {
              if (C === 0 || C === 1) {
                ws[cellRef].s.alignment.horizontal = 'left';
              } else if (C === 2 || C === 3) {
                ws[cellRef].s.alignment.horizontal = 'right';
              }
            }
          }
        }
      }

      const totalStyle = {
        font: { bold: true, name: 'Arial', sz: 10 },
        border: {
          top: { style: 'medium', color: { rgb: '000000' } },
          bottom: { style: 'medium', color: { rgb: '000000' } },
          left: { style: 'medium', color: { rgb: '000000' } },
          right: { style: 'medium', color: { rgb: '000000' } },
        },
        alignment: { horizontal: 'right', vertical: 'center' },
      };

      const lastStyle = {
        border: {
          top: { style: 'medium', color: { rgb: '000000' } },
        },
      };

      if (ws[`A${nextRow}`]) ws[`A${nextRow}`].s = totalStyle;
      if (ws[`B${nextRow}`]) ws[`B${nextRow}`].s = totalStyle;
      if (ws[`C${nextRow}`]) ws[`C${nextRow}`].s = totalStyle;
      if (ws[`D${nextRow}`]) ws[`D${nextRow}`].s = lastStyle;

      XLSX.utils.book_append_sheet(wb, ws, month.monthName);
    });

    // Generar el nombre del archivo
    const date = new Date();
    const dateString = `${date.getDate()}-${date.getMonth() + 1}-${date.getFullYear()}`;
    const fileName = `N3 ANTICIPOS ${workcenterName} ${year}_${dateString}.xlsx`;

    // Descargar el archivo
    XLSX.writeFile(wb, fileName);
  }

  addHeadersToSheet(ws, monthName, year, workcenterName, workCenterId) {
    XLSX.utils.sheet_add_aoa(ws, [
      ['N-3', 'ANTICIPO QUINCENAL'],
      ['MES:', monthName],
      ['AÑO', year],
      ['Centro de Trabajo:', workcenterName],
      ['', '', '3206'],
      ['D.N.I.', 'APELLIDOS Y NOMBRE', 'Anticipo Quincenal', 'observaciones'],
    ], { origin: 'A1' });

    console.log(workCenterId);

    // Fusionar celdas A5 y A6, B5 y B6
    // eslint-disable-next-line no-param-reassign
    if (!ws['!merges']) ws['!merges'] = [];
    ws['!merges'].push(
      { s: { r: 4, c: 0 }, e: { r: 5, c: 0 } }, // A5:A6
      { s: { r: 4, c: 1 }, e: { r: 5, c: 1 } }, // B5:B6
    );

    // Estilos para A1 y B1 (Anticipo Quincenal)
    if (ws.A1) {
      // eslint-disable-next-line no-param-reassign
      ws.A1.s = {
        font: {
          bold: true, sz: 26, color: { rgb: '000000' }, name: 'Arial Black',
        },
        fill: { fgColor: { rgb: 'FF0000' } },
        alignment: { horizontal: 'center', vertical: 'bottom' },
        border: { bottom: { style: 'medium', color: { rgb: '000000' } } },
      };
    }
    if (ws.B1) {
      // eslint-disable-next-line no-param-reassign
      ws.B1.s = {
        font: {
          bold: true, sz: 12, color: { rgb: '000000' }, name: 'Arial Black',
        },
        fill: { fgColor: { rgb: 'FF0000' } },
        alignment: { horizontal: 'center', vertical: 'bottom' },
        border: { bottom: { style: 'medium', color: { rgb: '000000' } } },
      };
    }
    // Estilos para A2 (Mes)
    if (ws.A2) {
      // eslint-disable-next-line no-param-reassign
      ws.A2.s = {
        font: {
          bold: true, sz: 12, color: { rgb: '000000' }, name: 'Arial',
        },
        fill: { fgColor: { rgb: 'FFFFFF' } },
        alignment: { horizontal: 'right', vertical: 'center' },
        border: {
          bottom: { style: 'thin', color: { rgb: '000000' } },
          right: { style: 'medium', color: { rgb: '000000' } },
        },
      };
    }
    // Estilos para B2 (Mes)
    if (ws.B2) {
      // eslint-disable-next-line no-param-reassign
      ws.B2.s = {
        font: {
          bold: true, sz: 16, color: { rgb: '000000' }, name: 'Arial',
        },
        fill: { fgColor: { rgb: 'FFFFFF' } },
        alignment: { horizontal: 'right', vertical: 'center' },
        border: {
          bottom: { style: 'thin', color: { rgb: '000000' } },
          right: { style: 'medium', color: { rgb: '000000' } },
        },
      };
    }
    // Estilos para A3 (Año)
    if (ws.A3) {
      // eslint-disable-next-line no-param-reassign
      ws.A3.s = {
        font: {
          bold: true, sz: 12, color: { rgb: '000000' }, name: 'Arial',
        },
        fill: { fgColor: { rgb: 'FFFFFF' } },
        alignment: { horizontal: 'right', vertical: 'center' },
        border: {
          bottom: { style: 'medium', color: { rgb: '000000' } },
          right: { style: 'medium', color: { rgb: '000000' } },
        },
      };
    }
    // Estilos para B3 (Año)
    if (ws.B3) {
      // eslint-disable-next-line no-param-reassign
      ws.B3.s = {
        font: {
          bold: true, sz: 16, color: { rgb: '000000' }, name: 'Arial',
        },
        fill: { fgColor: { rgb: 'FFFFFF' } },
        alignment: { horizontal: 'right', vertical: 'center' },
        border: {
          bottom: { style: 'medium', color: { rgb: '000000' } },
          right: { style: 'medium', color: { rgb: '000000' } },
        },
      };
    }
    // Estilos para A4 (Centro de Trabajo)
    if (ws.A4) {
      // eslint-disable-next-line no-param-reassign
      ws.A4.s = {
        font: {
          bold: true, sz: 12, color: { rgb: '000000' }, name: 'Arial',
        },
        fill: { fgColor: { rgb: 'FFFFFF' } },
        alignment: { horizontal: 'right', vertical: 'center' },
        border: {
          bottom: { style: 'medium', color: { rgb: '000000' } },
          right: { style: 'medium', color: { rgb: '000000' } },
        },
      };
    }
    // Estilos para B4 (Centro de Trabajo)
    if (ws.B4) {
      // eslint-disable-next-line no-param-reassign
      ws.B4.s = {
        font: {
          bold: true, sz: 16, color: { rgb: '000000' }, name: 'Arial',
        },
        fill: { fgColor: { rgb: 'FFFFFF' } },
        alignment: { horizontal: 'right', vertical: 'center', wrapText: true },
        border: {
          bottom: { style: 'medium', color: { rgb: '000000' } },
          right: { style: 'medium', color: { rgb: '000000' } },
        },
      };
    }

    // Estilos para A5
    if (ws.A5) {
      // eslint-disable-next-line no-param-reassign
      ws.A5.s = {
        font: {
          bold: true, sz: 10, color: { rgb: '000000' }, name: 'Arial',
        },
        fill: { fgColor: { rgb: 'FFFFFF' } },
        alignment: { horizontal: 'center', vertical: 'center' },
        border: {
          top: { style: 'medium', color: { rgb: '000000' } },
          bottom: { style: 'medium', color: { rgb: '000000' } },
          left: { style: 'medium', color: { rgb: '000000' } },
          right: { style: 'medium', color: { rgb: '000000' } },
        },
      };
    }
    // Estilos para B5
    if (ws.B5) {
      // eslint-disable-next-line no-param-reassign
      ws.B5.s = {
        font: {
          bold: true, sz: 10, color: { rgb: '000000' }, name: 'Arial',
        },
        fill: { fgColor: { rgb: 'FFFFFF' } },
        alignment: { horizontal: 'center', vertical: 'center' },
        border: {
          top: { style: 'medium', color: { rgb: '000000' } },
          bottom: { style: 'medium', color: { rgb: '000000' } },
          left: { style: 'medium', color: { rgb: '000000' } },
          right: { style: 'medium', color: { rgb: '000000' } },
        },
      };
    }

    // Estilos para A5
    if (ws.A6) {
      // eslint-disable-next-line no-param-reassign
      ws.A6.s = {
        font: {
          bold: true, sz: 10, color: { rgb: '000000' }, name: 'Arial',
        },
        fill: { fgColor: { rgb: 'FFFFFF' } },
        alignment: { horizontal: 'center', vertical: 'center' },
        border: {
          top: { style: 'medium', color: { rgb: '000000' } },
          bottom: { style: 'medium', color: { rgb: '000000' } },
          left: { style: 'medium', color: { rgb: '000000' } },
          right: { style: 'medium', color: { rgb: '000000' } },
        },
      };
    }
    // Estilos para B5
    if (ws.B6) {
      // eslint-disable-next-line no-param-reassign
      ws.B6.s = {
        font: {
          bold: true, sz: 10, color: { rgb: '000000' }, name: 'Arial',
        },
        fill: { fgColor: { rgb: 'FFFFFF' } },
        alignment: { horizontal: 'center', vertical: 'center' },
        border: {
          top: { style: 'medium', color: { rgb: '000000' } },
          bottom: { style: 'medium', color: { rgb: '000000' } },
          left: { style: 'medium', color: { rgb: '000000' } },
          right: { style: 'medium', color: { rgb: '000000' } },
        },
      };
    }

    // Estilos para C5
    if (ws.C5) {
      // eslint-disable-next-line no-param-reassign
      ws.C5.s = {
        font: {
          bold: true, sz: 12, color: { rgb: '000000' }, name: 'Arial',
        },
        fill: { fgColor: { rgb: 'FF0000' } },
        alignment: { horizontal: 'center', vertical: 'bottom' },
        border: {
          top: { style: 'medium', color: { rgb: '000000' } },
          bottom: { style: 'medium', color: { rgb: '000000' } },
          left: { style: 'medium', color: { rgb: '000000' } },
          right: { style: 'medium', color: { rgb: '000000' } },
        },
      };
    }

    // Estilos para C6
    if (ws.C6) {
      // eslint-disable-next-line no-param-reassign
      ws.C6.s = {
        font: {
          bold: true, sz: 10, color: { rgb: '000000' }, name: 'Arial Narrow',
        },
        fill: { fgColor: { rgb: 'FFFFFF' } },
        alignment: { horizontal: 'center', vertical: 'center', wrapText: true },
        border: {
          top: { style: 'medium', color: { rgb: '000000' } },
          bottom: { style: 'medium', color: { rgb: '000000' } },
          left: { style: 'medium', color: { rgb: '000000' } },
          right: { style: 'medium', color: { rgb: '000000' } },
        },
      };
    }
    // Estilos para D6
    if (ws.D6) {
      // eslint-disable-next-line no-param-reassign
      ws.D6.s = {
        font: {
          bold: true, sz: 10, color: { rgb: '000000' }, name: 'Arial Narrow',
        },
        fill: { fgColor: { rgb: 'FFFFFF' } },
        alignment: { horizontal: 'center', vertical: 'center' },
        border: {
          top: { style: 'medium', color: { rgb: '000000' } },
          bottom: { style: 'medium', color: { rgb: '000000' } },
          left: { style: 'medium', color: { rgb: '000000' } },
          right: { style: 'medium', color: { rgb: '000000' } },
        },
      };
    }

    // Estilos para A7
    if (ws.A7) {
      // eslint-disable-next-line no-param-reassign
      ws.A7.s = {
        border: {
          top: { style: 'medium', color: { rgb: '000000' } },
        },
      };
    }
    // Estilos para B7
    if (ws.B7) {
      // eslint-disable-next-line no-param-reassign
      ws.B7.s = {
        border: {
          top: { style: 'medium', color: { rgb: '000000' } },
        },
      };
    }

    // Mover cabeceras de fila 6 a 5 para que se vean en la fusión
    if (ws.A6) {
      // eslint-disable-next-line no-param-reassign
      ws.A5 = ws.A6;
      // eslint-disable-next-line no-param-reassign
      delete ws.A6;
    }
    if (ws.B6) {
      // eslint-disable-next-line no-param-reassign
      ws.B5 = ws.B6;
      // eslint-disable-next-line no-param-reassign
      delete ws.B6;
    }
  }

  getMonthsForYear(selectedYear) {
    const now = new Date();
    const currentYear = now.getFullYear();
    const currentMonth = now.getMonth();
    const year = parseInt(selectedYear, 10);

    if (year > currentYear) {
      throw new Error('El año seleccionado es futuro.');
    }

    const monthNames = [
      'ENERO', 'FEBRERO', 'MARZO', 'ABRIL', 'MAYO', 'JUNIO',
      'JULIO', 'AGOSTO', 'SEPTIEMBRE', 'OCTUBRE', 'NOVIEMBRE', 'DICIEMBRE',
    ];

    const mapMonth = (i) => ({
      id: i,
      monthNumber: i + 1,
      monthName: monthNames[i],
    });

    if (year < currentYear) {
      return Array.from({ length: 12 }, (_, i) => mapMonth(i));
    }
    return Array.from({ length: currentMonth + 1 }, (_, i) => mapMonth(i));
  }
}

export default new N3Service();
